import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import _ from "lodash"
import moment from "moment"
import Title from "../general/title"
import formatPhoneNumber from "../../helpers/formatPhone"
import clone from "clone"
import GroupedBar from "components/GroupedBar"
import ImageExport from "components/ImageExport"
import numeral from "numeral"
import FullTable from "components/FullTable"
import helpers from "helpers/helpers"
import { Link } from "react-router-dom"
import Switch from "react-switch"
import settings from "settings"

let limit = 20

class RealtorReport extends Component {
	constructor(props) {
		super(props)
		this.state = {
			sorted: [],
			filtered: [],
			columns: [
				{
					Header: "Community",
					accessor: "community",
					filterMethod: (f, r) => helpers.tableText(f, r, "community"),
				},
				{
					Header: "Total Closings",
					accessor: "total_closings",
				},
				{
					Header: "Total Realtor Involved Closings",
					accessor: "total_closings_realtor",
				},
				{
					Header: "Total Value of Realtor Involved Closings",
					accessor: "total",
				},
			],
			realtorStats: [
				{
					Header: "Name",
					accessor: "name",
					filterMethod: (f, r) => {
						if (
							r._original &&
							r._original.realtor_name &&
							r._original.realtor_name.toLowerCase().includes(f.value.toLowerCase())
						) {
							return true
						}
					},
					pdfValue: "realtor_name",
				},
				{
					Header: "Office",
					accessor: "office",
					filterMethod: (f, r) => {
						if (
							r._original &&
							r._original.realtor_office &&
							r._original.realtor_office.toLowerCase().includes(f.value.toLowerCase())
						) {
							return true
						}
					},
					pdfValue: "realtor_office",
				},
				/* {
					Header: "Email",
					accessor: "realtor_email",
				}, */
				{
					Header: "Total Sales",
					accessor: "total_sales",
				},
				{
					Header: "Total Cancels",
					accessor: "total_cancels",
				},
				{
					Header: "Total Net",
					accessor: "total_net",
				},
				{
					Header: "Total Closings",
					accessor: "total_closings",
				},
				{
					Header: "Total Sales & Closings",
					accessor: "total_sales_closings",
				},
				{
					Header: "Net Dollar Amount",
					accessor: "net_dollar_amount",
					Cell: (v) => {
						if (!v.value) return ""
						return numeral(v.value).format("$0,0")
					},
				},
				{
					Header: "Closing Dollar Amount",
					accessor: "closing_dollar_amount",
					Cell: (v) => {
						if (!v.value) return ""
						return numeral(v.value).format("$0,0")
					},
				},
				{
					Header: "Total Sales & Closings Amount",
					accessor: "total_sales_closings_amount",
					Cell: (v) => {
						if (!v.value) return ""
						return numeral(v.value).format("$0,0")
					},
				},
				{
					Header: "Address",
					accessor: "realtor_address",
					filterMethod: (f, r) => helpers.tableText(f, r, "realtor_address"),
				},
				{
					Header: "City",
					accessor: "realtor_city",
					filterMethod: (f, r) => helpers.tableText(f, r, "realtor_city"),
				},
				{
					Header: "State",
					accessor: "realtor_state",
					filterMethod: (f, r) => helpers.tableText(f, r, "realtor_state"),
				},
				{
					Header: "Zip",
					accessor: "realtor_zip",
					filterMethod: (f, r) => helpers.tableText(f, r, "realtor_zip"),
				},
				{
					Header: "Email",
					accessor: "realtor_email",
					filterMethod: (f, r) => helpers.tableText(f, r, "realtor_email"),
				},
				{
					Header: "Phone",
					accessor: "realtor_phone",
					filterMethod: (f, r) => helpers.tableText(f, r, "realtor_phone"),
				},
			],
			officeStats: [
				{
					Header: "Office",
					accessor: "office",
					filterMethod: (f, r) => helpers.tableText(f, r, "office"),
				},
				{
					Header: "Total Sales",
					accessor: "total_sales",
				},
				{
					Header: "Total Cancels",
					accessor: "total_cancels",
				},
				{
					Header: "Total Net",
					accessor: "total_net",
				},
				{
					Header: "Total Closings",
					accessor: "total_closings",
				},
				{
					Header: "Net Dollar Amount",
					accessor: "net_dollar_amount",
					Cell: (v) => {
						if (!v.value) return ""
						return numeral(v.value).format("$0,0")
					},
				},
				{
					Header: "Closing Dollar Amount",
					accessor: "closing_dollar_amount",
					Cell: (v) => {
						if (!v.value) return ""
						return numeral(v.value).format("$0,0")
					},
				},
			],
			showContractDate: true,
		}
	}

	buildTable = () => {
		let ret = []
		if (this.state.showContractDate) {
			_.forEach(this.props.payload.sales.current, (r) => {
				if (r.realtor_involved !== 1 || (r.bustout_date && !settings.realtorGross)) {
					return
				}
				let builder = _.find(this.props.payload.public.builders, { id: r.builder })
				let sp = _.find(this.props.payload.public.salespeople, { id: r.salesperson })
				let type = _.find(this.props.payload.public.lot_types, { id: r.lot_type })
				let property = _.find(this.props.payload.public.properties, { id: r.property })
				var v = {}
				let addedDate = moment.unix(r.addedDate)
				let saleDate = moment.unix(r.sale_date)
				v.property = property?.name || ""
				v.address = r.address
				v.lot_type = type ? type.name : ""
				v.realtor = r.realtor_name
				v.realtor_name_full = r.realtor_name_full
				v.realtorLicense = r.realtor
				v.realtor_phone = formatPhoneNumber(r.realtor_phone)
				v.realtor_email = r.realtor_email
				v.realtorAddress = r.realtor_address
				v.realtorCity = r.realtor_city
				v.realtorState = r.realtor_state
				v.realtorZip = r.realtor_zip
				v.realtorOffice = !r.realtor_office_name || r.realtor_office_name == "0" ? null : r.realtor_office_name
				v.realtorOfficeLicense = r.realtor_office
				v.realtor_office_phone = formatPhoneNumber(r.realtor_office_phone)
				v.realtor_office_email = r.realtor_office_email
				v.realtorOfficeAddress = r.realtor_office_address
				v.realtorOfficeCity = r.realtor_office_city
				v.realtorOfficeState = r.realtor_office_state
				v.realtorOfficeZip = r.realtor_office_zip
				v.sale_date = r.sale_date
				v.price = r.price
				v.closingDate = r.closing_date ? r.closing_date : ""
				v.closingInputDate = r.closing_report_time ? r.closing_report_time : ""
				v.builder = builder ? builder.name : ""
				v.salesperson = sp ? `${sp.first} ${sp.last}` : ""
				v.buyer_name = `${r.primary_first} ${r.primary_last}`
				v.addedDate = r.addedDate
				v.difference = addedDate.diff(saleDate, "days")
				ret.push(v)
			})
		} else {
			_.forEach(this.props.payload.exec.sales, (r) => {
				if (r.addedDate < this.props.currentDates.startStamp || r.addedDate > this.props.currentDates.endStamp)
					return
				if (r.realtor_involved !== 1 || (r.bustout_date && !settings.realtorGross)) {
					return
				}
				let builder = _.find(this.props.payload.public.builders, { id: r.builder })
				let sp = _.find(this.props.payload.public.salespeople, { id: r.salesperson })
				let type = _.find(this.props.payload.public.lot_types, { id: r.lot_type })
				let property = _.find(this.props.payload.public.properties, { id: r.property })
				var v = {}
				let addedDate = moment.unix(r.addedDate)
				let saleDate = moment.unix(r.sale_date)
				v.address = r.address
				v.property = property?.name || ""
				v.lot_type = type ? type.name : ""
				v.realtor = r.realtor_name
				v.realtor_name_full = r.realtor_name_full
				v.realtorLicense = r.realtor
				v.realtor_phone = formatPhoneNumber(r.realtor_phone)
				v.realtor_email = r.realtor_email
				v.realtorAddress = r.realtor_address
				v.realtorCity = r.realtor_city
				v.realtorState = r.realtor_state
				v.realtorZip = r.realtor_zip
				v.realtorOffice = !r.realtor_office_name || r.realtor_office_name == "0" ? null : r.realtor_office_name
				v.realtorOfficeLicense = r.realtor_office
				v.realtor_office_phone = formatPhoneNumber(r.realtor_office_phone)
				v.realtor_office_email = r.realtor_office_email
				v.realtorOfficeAddress = r.realtor_office_address
				v.realtorOfficeCity = r.realtor_office_city
				v.realtorOfficeState = r.realtor_office_state
				v.realtorOfficeZip = r.realtor_office_zip
				v.sale_date = r.sale_date
				v.price = r.price
				v.closingDate = r.closing_date ? r.closing_date : ""
				v.closingInputDate = r.closing_report_time ? r.closing_report_time : ""
				v.builder = builder ? builder.name : ""
				v.salesperson = sp ? `${sp.first} ${sp.last}` : ""
				v.buyer_name = `${r.primary_first} ${r.primary_last}`
				v.addedDate = r.addedDate
				v.difference = addedDate.diff(saleDate, "days")
				ret.push(v)
			})
		}

		ret = _.sortBy(ret, "sale_date").reverse()
		//console.log(ret)
		return ret
	}

	buildWithout = () => {
		var ret = []
		if (this.state.showContractDate) {
			_.forEach(this.props.payload.sales.current, (r) => {
				if (r.realtor_involved == 1 || (r.bustout_date && !settings.realtorGross)) {
					return
				}
				let builder = _.find(this.props.payload.public.builders, { id: r.builder })
				let sp = _.find(this.props.payload.public.salespeople, { id: r.salesperson })
				let type = _.find(this.props.payload.public.lot_types, { id: r.lot_type })
				var v = {}
				let addedDate = moment.unix(r.addedDate)
				let saleDate = moment.unix(r.sale_date)
				v.address = r.address
				v.lot_type = type ? type.name : ""
				v.sale_date = r.sale_date
				v.price = r.price
				v.closingDate = r.closing_date ? r.closing_date : ""
				v.builder = builder ? builder.name : ""
				v.salesperson = sp ? `${sp.first} ${sp.last}` : ""
				v.buyer_name = `${r.primary_first} ${r.primary_last}`
				v.addedDate = r.addedDate
				v.difference = addedDate.diff(saleDate, "days")
				ret.push(v)
			})
		} else {
			// by added date, so look into exec sales
			_.forEach(this.props.payload.exec.sales, (r) => {
				if (r.addedDate < this.props.currentDates.startStamp || r.addedDate > this.props.currentDates.endStamp)
					return
				if (r.realtor_involved == 1 || (r.bustout_date && !settings.realtorGross)) {
					return
				}
				let builder = _.find(this.props.payload.public.builders, { id: r.builder })
				let sp = _.find(this.props.payload.public.salespeople, { id: r.salesperson })
				let type = _.find(this.props.payload.public.lot_types, { id: r.lot_type })
				var v = {}
				let addedDate = moment.unix(r.addedDate)
				let saleDate = moment.unix(r.sale_date)
				v.address = r.address
				v.lot_type = type ? type.name : ""
				v.sale_date = r.sale_date
				v.price = r.price
				v.closingDate = r.closing_date ? r.closing_date : ""
				v.builder = builder ? builder.name : ""
				v.salesperson = sp ? `${sp.first} ${sp.last}` : ""
				v.buyer_name = `${r.primary_first} ${r.primary_last}`
				v.addedDate = r.addedDate
				v.difference = addedDate.diff(saleDate, "days")
				ret.push(v)
			})
		}

		ret = _.sortBy(ret, "sale_date").reverse()
		//console.log(ret)
		return ret
	}

	buildRealtorStatistics = () => {
		var ret = []
		let store = {}
		let model = {
			name: {},
			office: {},
			realtor_name: "",
			realtor_office: "",
			total_sales: 0,
			total_cancels: 0,
			total_sales_closings: 0,
			total_net: 0,
			total_closings: 0,
			net_dollar_amount: 0,
			closing_dollar_amount: 0,
			total_sales_closings_amount: 0
		}
		// First sales
		_.forEach(this.props.payload.sales.current, (r) => {
			if (!r.realtor || r.realtor_involved !== 1 || !r.realtor_name) return
			if (!_.has(store, r.realtor)) {
				_.setWith(store, r.realtor, _.clone(model), Object)
			}
			r.realtor_name = _.startCase(_.toLower(r.realtor_name))
			r.realtor_office_name = _.startCase(_.toLower(r.realtor_office_name))
			store[r.realtor].realtor_name = r.realtor_name
			store[r.realtor].realtor_office = r.realtor_office_name
			store[r.realtor].realtor_email = r.realtor_email
			store[r.realtor].realtor_address = r.realtor_address
			store[r.realtor].realtor_city = r.realtor_city
			store[r.realtor].realtor_state = r.realtor_state
			store[r.realtor].realtor_zip = r.realtor_zip
			store[r.realtor].realtor_email = r.realtor_email
			store[r.realtor].realtor_phone = r.realtor_phone
			store[r.realtor].name = <Link to={`/realtorReport/realtor/${r.realtor}`}>{r.realtor_name}</Link>
			store[r.realtor].office = (
				<Link to={`/realtorReport/brokerage/${r.realtor_office}`}>{r.realtor_office_name}</Link>
			)
			store[r.realtor].total_sales++
			store[r.realtor].net_dollar_amount += r.price
			if(r.closing_date && r.closing_date >= this.props.currentDates.startStamp && r.closing_date <= this.props.currentDates.endStamp) {
				store[r.realtor].total_sales_closings++
				store[r.realtor].total_sales_closings_amount += r.closing_price
			}
		})
		// then cancels
		_.forEach(this.props.payload.bustouts.current, (r) => {
			if (!r.realtor || r.realtor_involved !== 1 || !r.realtor_name) return
			if (!_.has(store, r.realtor)) {
				_.setWith(store, r.realtor, _.clone(model), Object)
			}
			r.realtor_name = _.startCase(_.toLower(r.realtor_name))
			r.realtor_office_name = _.startCase(_.toLower(r.realtor_office_name))
			store[r.realtor].realtor_name = r.realtor_name
			store[r.realtor].realtor_office = r.realtor_office_name
			store[r.realtor].realtor_address = r.realtor_address
			store[r.realtor].realtor_city = r.realtor_city
			store[r.realtor].realtor_state = r.realtor_state
			store[r.realtor].realtor_zip = r.realtor_zip
			store[r.realtor].realtor_email = r.realtor_email
			store[r.realtor].realtor_phone = r.realtor_phone
			store[r.realtor].name = <Link to={`/realtorReport/realtor/${r.realtor}`}>{r.realtor_name}</Link>
			store[r.realtor].office = (
				<Link to={`/realtorReport/brokerage/${r.realtor_office}`}>{r.realtor_office_name}</Link>
			)

			store[r.realtor].total_cancels++
			store[r.realtor].net_dollar_amount -= r.price
		})
		// then closigns
		_.forEach(this.props.payload.closings.current, (r) => {
			if (!r.realtor || r.realtor_involved !== 1 || !r.realtor_name) return
			if (!_.has(store, r.realtor)) {
				_.setWith(store, r.realtor, _.clone(model), Object)
			}
			r.realtor_name = _.startCase(_.toLower(r.realtor_name))
			r.realtor_office_name = _.startCase(_.toLower(r.realtor_office_name))
			store[r.realtor].realtor_name = r.realtor_name
			store[r.realtor].realtor_office = r.realtor_office_name
			store[r.realtor].realtor_address = r.realtor_address
			store[r.realtor].realtor_city = r.realtor_city
			store[r.realtor].realtor_state = r.realtor_state
			store[r.realtor].realtor_zip = r.realtor_zip
			store[r.realtor].realtor_email = r.realtor_email
			store[r.realtor].realtor_phone = r.realtor_phone
			store[r.realtor].name = <Link to={`/realtorReport/realtor/${r.realtor}`}>{r.realtor_name}</Link>
			store[r.realtor].office = (
				<Link to={`/realtorReport/brokerage/${r.realtor_office}`}>{r.realtor_office_name}</Link>
			)

			store[r.realtor].total_closings++
			store[r.realtor].closing_dollar_amount += r.closing_price
		})

		_.forEach(store, (v, k) => {
			v.license = k
			v.total_net = v.total_sales - v.total_cancels
			ret.push(v)
		})
		//ret = _.sortBy(ret, "closing_dollar_amount").reverse()
		return ret
	}

	buildOfficeStats = () => {
		var ret = []
		let store = {}
		let model = {
			office: "",
			total_sales: 0,
			total_cancels: 0,
			total_net: 0,
			total_closings: 0,
			net_dollar_amount: 0,
			closing_dollar_amount: 0,
		}
		// First sales
		_.forEach(this.props.payload.sales.current, (r) => {
			if (!r.realtor_office || r.realtor_involved !== 1) return
			if (!_.has(store, r.realtor_office)) {
				_.setWith(store, r.realtor_office, _.clone(model), Object)
			}
			r.realtor_office_name = _.startCase(_.toLower(r.realtor_office_name))
			store[r.realtor_office].office = (
				<Link to={`/realtorReport/brokerage/${r.realtor_office}`}>{r.realtor_office_name}</Link>
			)
			store[r.realtor_office].realtor_office = r.realtor_office_name
			store[r.realtor_office].office = r.realtor_office_name
			store[r.realtor_office].total_sales++
			store[r.realtor_office].net_dollar_amount += r.price
		})
		// then cancels
		_.forEach(this.props.payload.bustouts.current, (r) => {
			if (!r.realtor_office || r.realtor_involved !== 1) return
			if (!_.has(store, r.realtor_office)) {
				_.setWith(store, r.realtor_office, _.clone(model), Object)
			}
			r.realtor_office_name = _.startCase(_.toLower(r.realtor_office_name))
			store[r.realtor_office].realtor_office = r.realtor_office_name
			store[r.realtor_office].office = (
				<Link to={`/realtorReport/brokerage/${r.realtor_office}`}>{r.realtor_office_name}</Link>
			)
			store[r.realtor_office].total_cancels++
			store[r.realtor_office].net_dollar_amount -= r.price
		})
		// then closigns
		_.forEach(this.props.payload.closings.current, (r) => {
			if (!r.realtor_office || r.realtor_involved !== 1) return
			if (!_.has(store, r.realtor_office)) {
				_.setWith(store, r.realtor_office, _.clone(model), Object)
			}
			r.realtor_office_name = _.startCase(_.toLower(r.realtor_office_name))
			store[r.realtor_office].realtor_office = r.realtor_office_name
			store[r.realtor_office].office = (
				<Link to={`/realtorReport/brokerage/${r.realtor_office}`}>{r.realtor_office_name}</Link>
			)
			store[r.realtor_office].total_closings++
			store[r.realtor_office].closing_dollar_amount += r.price
		})

		_.forEach(store, (v, k) => {
			v.license = k
			v.total_net = v.total_sales - v.total_cancels
			ret.push(v)
		})

		//ret = _.sortBy(ret, "closing_dollar_amount").reverse()
		return ret
	}

	realtorStatsTable = () => {
		let model = {
			closings: 0,
			closings_realtor: 0,
			value: 0,
		}
		let store = {}
		_.forEach(this.props.payload.closings.current, (v) => {
			let path = v.property
			if (!_.has(store, path)) {
				_.setWith(store, path, _.clone(model))
			}
			store[v.property].closings++
			if (v.realtor_involved) {
				store[v.property].closings_realtor++
				store[v.property].value += v.price
			}
		})

		let ret = []
		_.forEach(store, (v, k) => {
			k = parseInt(k)
			try {
				let property = _.find(this.props.payload.public.properties, { id: k })
				if (!property) throw new Error(`Cannot find property.`)
				ret.push({
					community: property.name,
					total_closings: v.closings,
					total_closings_realtor: v.closings_realtor,
					total: numeral(v.value).format("$0,0"),
				})
			} catch (e) {
				console.log(e)
			}
		})
		return ret
	}

	buildTotalSales = () => {
		if (_.has(this.props, "payload.builders")) {
			var keys = Object.keys(this.props.payload.builders)
			return keys.map((v, i) => {
				var total = 0
				this.props.payload.sales.current.forEach((val) => {
					if (val.builder_id == v) {
						total += 1
					}
				})
				return (
					<li className="statBreakout__item" key={i}>
						<div>
							<div className="statBreakout__stat">{total}</div>
							<div className="statBreakout__info">{this.props.payload.builders[v]}</div>
						</div>
					</li>
				)
			})
		}
	}

	realtors = () => {
		var [labels, soldArray, closedArray] = [[], [], []]
		var ret = {}
		let model = {
			sales: 0,
			closed: 0,
			total: 0,
		}
		// First sales
		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.bustout_date && !settings.realtorGross) return
			if (v.realtor_involved == 0 || !v.realtor_name) {
				return
			}
			if (!_.has(ret, `${v.realtor_name}`)) {
				ret[`${v.realtor_name}`] = clone(model)
			}
			ret[`${v.realtor_name}`].sales++
		})
		// Next closings
		_.forEach(this.props.payload.closings.current, (v) => {
			if (v.realtor_involved == 0 || !v.realtor_name) {
				return
			}
			if (!_.has(ret, `${v.realtor_name}`)) {
				ret[`${v.realtor_name}`] = clone(model)
			}
			ret[`${v.realtor_name}`].closed++
		})

		// add em up
		_.forEach(ret, (v, k) => {
			ret[k].total = v.sales + v.closed
		})

		// Compile data
		var d = []
		_.forEach(ret, (v, k) => {
			var sales = v.sales || 0
			var closed = v.closed || 0
			d.push({
				label: k,
				sold: sales,
				closed: closed,
				total: sales + closed,
			})
		})
		d = _.orderBy(d, ["total", "closed"], ["desc", "desc"]).slice(0, limit)
		_.forEach(d, (v) => {
			labels.push(v.label)
			soldArray.push(v.sold)
			closedArray.push(v.closed)
		})
		let series = [
			{
				name: "Sold",
				data: soldArray,
			},
			{
				name: "Closed",
				data: closedArray,
			},
		]

		let options = {
			plotOptions: {
				bar: {
					horizontal: true,
				},
			},
		}

		return <GroupedBar series={series} categories={labels} options={options} />
	}

	realtorOffices = () => {
		var [labels, soldArray, closedArray] = [[], [], []]
		var ret = {}
		let model = {
			sales: 0,
			closed: 0,
			total: 0,
		}
		// First sales
		_.forEach(this.props.payload.sales.current, (v) => {
			if (v.bustout_date && !settings.realtorGross) return
			if (v.realtor_involved == 0 || !v.realtor_office_name) {
				return
			}
			if (!_.has(ret, `${v.realtor_office_name}`)) {
				ret[`${v.realtor_office_name}`] = clone(model)
			}
			ret[`${v.realtor_office_name}`].sales++
		})
		// Next closings
		_.forEach(this.props.payload.closings.current, (v) => {
			if (!v.realtor_office_name) {
				return
			}
			if (!_.has(ret, `${v.realtor_office_name}`)) {
				ret[`${v.realtor_office_name}`] = clone(model)
			}
			ret[`${v.realtor_office_name}`].closed++
		})

		// add em up
		_.forEach(ret, (v, k) => {
			ret[k].total = v.sales + v.closed
		})

		// Compile data
		var d = []
		_.forEach(ret, (v, k) => {
			var sales = v.sales || 0
			var closed = v.closed || 0
			d.push({
				label: k,
				sold: sales,
				closed: closed,
				total: sales + closed,
			})
		})
		d = _.orderBy(d, ["total", "closed"], ["desc", "desc"]).slice(0, limit)

		_.forEach(d, (v) => {
			labels.push(v.label)
			soldArray.push(v.sold)
			closedArray.push(v.closed)
		})
		let series = [
			{
				name: "Sold",
				data: soldArray,
			},
			{
				name: "Closed",
				data: closedArray,
			},
		]

		let options = {
			plotOptions: {
				bar: {
					horizontal: true,
				},
			},
		}

		return <GroupedBar series={series} categories={labels} options={options} />
	}

	realtorInvolved = () => {
		var count = 0
		var total = 0
		if (_.has(this.props, "payload.sales.current")) {
			_.forEach(this.props.payload.sales.current, (r) => {
				if (r.bustout_date && !settings.realtorGross) return
				if (r.realtor_involved == 1) {
					count++
				}
				total++
			})
		}

		return (
			<React.Fragment>
				{count}
				<span>/{total}</span>
			</React.Fragment>
		)
	}

	realtorInvolvedPercent = () => {
		var count = 0
		var total = 0
		_.forEach(this.props.payload.sales.current, (r) => {
			if (r.bustout_date && !settings.realtorGross) return
			total++
			if (r.realtor_involved == 1) {
				count++
			}
		})
		if (count == 0) {
			return 0
		}

		var ret = Math.round((count / total) * 100)
		return ret
	}

	realtorClosings = () => {
		var count = 0
		var total = 0
		if (_.has(this.props, "payload.closings.current")) {
			_.forEach(this.props.payload.closings.current, (r) => {
				if (r.bustout_date && !settings.realtorGross) return // should never be here, but protection
				if (r.realtor_involved == 1) {
					count++
				}
				total++
			})
		}

		return (
			<React.Fragment>
				{count}
				<span>/{total}</span>
			</React.Fragment>
		)
	}

	realtorClosingsInvolvement = () => {
		var count = 0
		var total = 0
		if (_.has(this.props, "payload.closings.current")) {
			_.forEach(this.props.payload.closings.current, (r) => {
				total++
				if (r.realtor_involved == 1) {
					count++
				}
			})
		}
		if (count == 0) {
			return 0
		}

		var ret = Math.round((count / total) * 100)
		return ret
	}

	realtorClosingsValue = () => {
		var total = 0
		if (_.has(this.props, "payload.closings.current")) {
			_.forEach(this.props.payload.closings.current, (r) => {
				if (r.realtor_involved == 1) total += r.price
			})
		}
		let ret = numeral(total).format("$0,0")
		return ret
	}

	realtorSalesValue = () => {
		var total = 0
		if (_.has(this.props, "payload.sales.current")) {
			_.forEach(this.props.payload.sales.current, (r) => {
				if ((r.bustout_date && !settings.realtorGross) || r.realtor_involved === 0) return
				total += r.price
			})
		}
		let ret = numeral(total).format("$0,0")
		return ret
	}

	SwitchDates = () => {
		return (
			<div className="switch mt-3" onClick={(e) => e.stopPropagation()}>
				<Switch
					onChange={() => {
						this.setState({ showContractDate: !this.state.showContractDate })
					}}
					checked={this.state.showContractDate}
					checkedIcon={false}
					uncheckedIcon={false}
					key={"switch"}
					id={"switch"}
				/>{" "}
				<p>Based on {this.state.showContractDate ? "Contract" : "Input"} Date</p>
			</div>
		)
	}

	render() {
		const columns = [
			{
				Header: "Community",
				accessor: "property",
				filterMethod: (f, r) => helpers.tableText(f, r, "property"),
			},
			{
				Header: "Sold Address",
				accessor: "address",
				filterMethod: (f, r) => helpers.tableText(f, r, "address"),
			},
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
			{
				Header: "Lot Type",
				accessor: "lot_type",
				filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
			},
			{
				Header: "Salesperson",
				accessor: "salesperson",
				filterMethod: (f, r) => helpers.tableText(f, r, "salesperson"),
			},
			{
				Header: "Buyer Name",
				accessor: "buyer_name",
				filterMethod: (f, r) => helpers.tableText(f, r, "buyer_name"),
			},
			{
				Header: "Realtor",
				accessor: "realtor",
				filterMethod: (f, r) => helpers.tableText(f, r, "realtor"),
			},
			{
				Header: "Realtor License",
				accessor: "realtorLicense",
			},
			{
				Header: "Realtor Office",
				accessor: "realtorOffice",
				filterMethod: (f, r) => helpers.tableText(f, r, "realtorOffice"),
			},
			{
				Header: "Brokerage License",
				accessor: "realtorOfficeLicense",
			},
			{
				Header: "Realtor Email",
				accessor: "realtor_email",
				filterMethod: (f, r) => helpers.tableText(f, r, "realtor_email"),
			},
			{
				Header: "Realtor Address",
				accessor: "realtorAddress",
				filterMethod: (f, r) => helpers.tableText(f, r, "realtorAddress"),
			},
			{
				Header: "Realtor City",
				accessor: "realtorCity",
				filterMethod: (f, r) => helpers.tableText(f, r, "realtorCity"),
			},
			{
				Header: "Realtor State",
				accessor: "realtorState",
				filterMethod: (f, r) => helpers.tableText(f, r, "realtorState"),
			},
			{
				Header: "Realtor Zip",
				accessor: "realtorZip",
				filterMethod: (f, r) => helpers.tableText(f, r, "realtorZip"),
			},
			{
				Header: "Contract Date",
				accessor: "sale_date",
				Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
				sort: "desc",
				filterMethod: (f, r) => helpers.dateFilter(f, r),
			},
			{
				Header: "Input Date",
				accessor: "addedDate",
				Cell: (props) => {
					if (props.value) {
						return moment.unix(props.value).format("MM/DD/YY")
					}
					return ""
				},
				filterMethod: (f, r) => helpers.dateFilter(f, r),
				sort: "desc",
			},
			{
				Header: "Days Difference",
				accessor: "difference",
			},
			{
				Header: "Closing Date",
				accessor: "closingDate",
				Cell: (props) => {
					if (props.value) {
						return moment.unix(props.value).format("MM/DD/YY")
					}
					return ""
				},
				filterMethod: (f, r) => helpers.dateFilter(f, r),
				sort: "desc",
			},
			{
				Header: "Closing Input Date",
				accessor: "closingInputDate",
				Cell: (props) => {
					if (props.value) {
						return moment.unix(props.value).format("MM/DD/YY")
					}
					return ""
				},
				filterMethod: (f, r) => helpers.dateFilter(f, r),
				sort: "desc",
			},
			{
				Header: "Sale Price",
				accessor: "price",
				Cell: (props) => numeral(props.value).format("$0,0"),
				Footer: (props) => helpers.tableTotals(props, "price", "$0,0"),
			},
		]

		const columnsWithout = [
			{
				Header: "Sold Address",
				accessor: "address",
				filterMethod: (f, r) => helpers.tableText(f, r, "address"),
			},
			{
				Header: "Builder",
				accessor: "builder",
				filterMethod: (f, r) => helpers.tableText(f, r, "builder"),
			},
			{
				Header: "Lot Type",
				accessor: "lot_type",
				filterMethod: (f, r) => helpers.tableText(f, r, "lot_type"),
			},
			{
				Header: "Salesperson",
				accessor: "salesperson",
				filterMethod: (f, r) => helpers.tableText(f, r, "salesperson"),
			},
			{
				Header: "Buyer Name",
				accessor: "buyer_name",
				filterMethod: (f, r) => helpers.tableText(f, r, "buyer_name"),
			},
			{
				Header: "Contract Date",
				accessor: "sale_date",
				Cell: (props) => moment.unix(props.value).format("MM/DD/YY"),
				sort: "desc",
				filterMethod: (f, r) => helpers.dateFilter(f, r),
			},
			{
				Header: "Input Date",
				accessor: "addedDate",
				Cell: (props) => {
					if (props.value) {
						return moment.unix(props.value).format("MM/DD/YY")
					}
					return ""
				},
				filterMethod: (f, r) => helpers.dateFilter(f, r),
				sort: "desc",
			},
			{
				Header: "Days Difference",
				accessor: "difference",
			},
			{
				Header: "Closing Date",
				accessor: "closingDate",
				Cell: (props) => {
					if (props.value) {
						return moment.unix(props.value).format("MM/DD/YY")
					}
					return ""
				},
				filterMethod: (f, r) => helpers.dateFilter(f, r),
				sort: "desc",
			},
			{
				Header: "Sale Price",
				accessor: "price",
				Cell: (props) => numeral(props.value).format("$0,0"),
				Footer: (props) => helpers.tableTotals(props, "price", "$0,0"),
			},
		]

		return (
			<div className="realtorReport">
				<div className="imageGroup">
					<Title title="Realtor Report" />
					<div className="statBreakout">
						<ul className="boxList__list">
							<li className="boxList__item">
								<span>{this.realtorInvolved()}</span>
								<br />
								<span>Realtor Involved Sales</span>
							</li>
							<li className="boxList__item">
								<span>{this.realtorInvolvedPercent()}%</span>
								<br />
								<span>Realtor Sales Involvement</span>
							</li>
							<li className="boxList__item">
								<span>{this.realtorClosings()}</span>
								<br />
								<span>Realtor Involved Closings</span>
							</li>
							<li className="boxList__item">
								<span>{this.realtorClosingsInvolvement()}%</span>
								<br />
								<span>Realtor Closings Involvement</span>
							</li>
							<li className="boxList__item boxList__item--small">
								<span>{this.realtorSalesValue()}</span>
								<br />
								<span>Realtor Sales Value</span>
							</li>
							<li className="boxList__item boxList__item--small">
								<span>{this.realtorClosingsValue()}</span>
								<br />
								<span>Realtor Closings Value</span>
							</li>
						</ul>
					</div>
					<div className="statBox">
						<div className="statBox__row">
							<div className="statBox__box">
								<ImageExport name="RealtorOffices" />
								<h3 className="statBox__title">Top {limit} Performing Realtor Offices</h3>
								{this.realtorOffices()}
							</div>
						</div>
					</div>
				</div>
				<div className="imageGroup">
					<div className="statBox">
						<div className="statBox__row">
							<div className="statBox__box">
								<ImageExport name="Realtors" />
								<h3 className="statBox__title">Top {limit} Performing Realtors</h3>
								{this.realtors()}
							</div>
						</div>
					</div>
					<div className="content">
						<h2>Realtor Statistics</h2>
						<p className="mid infoNote" style={{ margin: 0 }}>
							<i className={`fas fa-info-circle`} />
							Total Sales & Closings are based on sales that happened AND closed during the time period chosen.
						</p>
						<FullTable
							data={this.buildRealtorStatistics()}
							columns={this.state.realtorStats}
							name="realtor__realtorStats"
							title="Realtor Statistics"
							unset={["name", "office"]}
							defaultSorted={[
								{
									id: "closing_dollar_amount",
									desc: true,
								},
							]}
						/>
						<h2>Realtor Office Statistics</h2>
						<FullTable
							data={this.buildOfficeStats()}
							columns={this.state.officeStats}
							name="realtor_officestats"
							title="Realtor Office Statistics"
							unset={["office"]}
							defaultSorted={[
								{
									id: "closing_dollar_amount",
									desc: true,
								},
							]}
						/>
					</div>
				</div>
				<div className="imageGroup">
					<div className="content">
						<h2>
							Realtor Involved Sales for {this.props.currentDates.startText} -{" "}
							{this.props.currentDates.endText}
						</h2>
						<this.SwitchDates />
						<FullTable
							data={this.buildTable()}
							columns={columns}
							name="realtor__involvedSales"
							title="Realtor Involved Sales"
							classNames={`small`}
						/>
						<ImageExport name="RealtorSalesTable" />
						<h2>Sales Without Realtor</h2>
						<this.SwitchDates />
						<FullTable
							data={this.buildWithout()}
							columns={columnsWithout}
							name="realtor__withoutRealtor"
							title="Sales Without Realtor"
							classNames={`small`}
						/>
						<h2>Realtor Statistics by Community</h2>
						<FullTable
							data={this.realtorStatsTable()}
							columns={this.state.columns}
							name="realtor_statistics"
							title="Realtor Statistics"
						/>
					</div>
				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(RealtorReport)
